<div class="layout" [class.no-clickable]="lockUserInteraction">
  <div class="layout__page">
    <qb-ita-header
      logoImage="/assets/img/logos/verti.svg"
      [isLogoClickable]="true"
      [headerText]="'HEADER.DEFAULT' | translate"
      [promotionalImage]="headerPromotionalImage"
      [promotionalUrl]="headerPromotionalUrl"
      [headerPromotionalShowInd]="headerPromotionalShowInd"
      [vertiUrl]="VERTI_URL"
      [showPhoneNumber]="true"
      [phoneIcon]="'verti-phone-24'"
      [phoneNumber]="initFlowData?.campaignInfo?.telephoneNumber"
      (phoneNumberClick)="onHeaderPhoneNumberClick()"
    ></qb-ita-header>
    <div
      class="layout__scroll-container"
      [ngClass]="{ button__mobile: !hideNextButtonMobile && !hideNextButton }"
      tabindex="-1"
    >
      <div class="layout__container">
        <div
          class="layout__content"
          [ngClass]="{ 'layout__content--center': contentCentered, 'layout__content--padding': contentPadding }"
        >
          <div class="form-wrapper">
            <div role="navigation">
              <ng-container *ngIf="showSteps && steps?.length && currentStep">
                <qb-ita-step
                  class="layout__steps--desktop"
                  [steps]="steps"
                  [currentStep]="currentStep"
                  [percent]="percent"
                  (stepClicked)="stepClicked.emit($event)"
                ></qb-ita-step>
                <div class="layout__steps--container">
                  <ng-container *ngTemplateOutlet="backButton; context: { hideTextMobile: true }"></ng-container>
                  <qb-ita-circle-progress-bar
                    class="layout__steps--mobile"
                    [steps]="steps"
                    [currentStep]="currentStep"
                    [percent]="percent"
                  ></qb-ita-circle-progress-bar>
                </div>
              </ng-container>
              <!-- If there are no steps, back button should show the text label -->
              <ng-container *ngIf="!(showSteps && steps?.length && currentStep)">
                <ng-container *ngTemplateOutlet="backButton; context: { hideTextMobile: false }"></ng-container>
              </ng-container>
            </div>

            <main role="main">
              <div
                class="layout__form"
                [ngClass]="{
                  footer__bottom: !hideNextButtonMobile && !onDesktop
                }"
              >
                <div *ngIf="stepPageTitle || stepPageDescription" class="layout__header">
                  <ion-icon *ngIf="stepPageIcon" class="{{ stepPageIcon }} layout__icon color--secondary3"></ion-icon>
                  <h2 *ngIf="stepPageTitle" class="layout__title text--24 text--bold">{{ stepPageTitle }}</h2>
                  <h3 *ngIf="stepPageDescription" class="layout__subtitle text--16">
                    <span [innerHtml]="stepPageDescription | qbItaSafeHtml"></span>
                  </h3>
                </div>

                <ion-grid class="full-width">
                  <ion-row>
                    <ion-col
                      size="12"
                      *ngIf="showSummaryLite && !pageLoading && (summaryLiteData$ | async)"
                      class="layout__summary--mobile"
                    >
                      <qb-ita-quotation-summary-lite
                        [summaryData]="summaryLiteData$ | async"
                        [showCoverages]="showSummaryLiteCoverages"
                        [showSummaryPDF]="showSummaryLitePDF"
                        mobileHeaderIcon="verti-document-16"
                        (downloadPDFClick)="summaryLitePDFClick.emit()"
                        [pdfIcon]="'verti-pdf-16'"
                      ></qb-ita-quotation-summary-lite>
                    </ion-col>

                    <ion-col
                      size="12"
                      class="layout__main-content"
                      [attr.size-md]="showSummaryLite && !pageLoading ? 6 : 12"
                    >
                      <div
                        class="layout__content-wrapper"
                        [ngClass]="{ 'layout__content-wrapper--no-padding': showSummaryLite }"
                      >
                        <ng-content></ng-content>

                        <div class="layout__content-cta">
                          <div *ngIf="!hideNextButton">
                            <qb-ita-button
                              *ngIf="!hideNextButton"
                              class="layout__next-button"
                              [label]="nextBtnTitle || ('CONTINUE_BUTTON.TITLE' | translate)"
                              (btnClick)="nextBtnClick.emit()"
                              [buttonPosition]="nextBtnPosition || 'center'"
                              [disabled]="nextBtnDisabled"
                              [hasMinWidth]="true"
                              [showSpinner]="nextButtonShowSpinner"
                            ></qb-ita-button>
                          </div>

                          <div *ngIf="!hideSecondaryButton">
                            <qb-ita-button
                              *ngIf="!hideSecondaryButton"
                              class="layout__next-button"
                              color="secondary"
                              [label]="secondaryBtnTitle || ('BACK_BUTTON.TITLE' | translate)"
                              (btnClick)="secondaryBtnClick.emit()"
                              buttonPosition="center"
                              [disabled]="secondaryBtnDisabled"
                              [showSpinner]="secondaryButtonShowSpinner"
                            ></qb-ita-button>
                          </div>
                        </div>
                      </div>
                    </ion-col>

                    <ion-col
                      *ngIf="showSummaryLite && !pageLoading && (summaryLiteData$ | async)"
                      size-md="6"
                      class="layout__summary"
                    >
                      <qb-ita-quotation-summary-lite
                        [summaryData]="summaryLiteData$ | async"
                        [showCoverages]="showSummaryLiteCoverages"
                        [showSummaryPDF]="showSummaryLitePDF"
                        mobileHeaderIcon="verti-document-16"
                        (downloadPDFClick)="summaryLitePDFClick.emit()"
                        [pdfIcon]="'verti-pdf-16'"
                      ></qb-ita-quotation-summary-lite>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </main>
          </div>
        </div>
        <div>
          <div *ngIf="showSeoFooter" class="footer__seo-container">
            <qb-ita-seo-footer
              [seoTitle]="
                flowName === Flow.NEW_QUOTATION
                  ? ('SEO_FOOTER.FULL_QUOTE.TITLE' | translate)
                  : ('SEO_FOOTER.QUICK_QUOTE.TITLE' | translate)
              "
              [seoContent]="
                flowName === Flow.NEW_QUOTATION
                  ? ('SEO_FOOTER.FULL_QUOTE.CONTENT' | translate)
                  : ('SEO_FOOTER.QUICK_QUOTE.CONTENT' | translate)
              "
            ></qb-ita-seo-footer>
          </div>
          <div class="footer__container">
            <qb-ita-footer [footerLinks]="footerLinks"></qb-ita-footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #backButton let-hideTextMobile="hideTextMobile">
  <qb-ita-back-button
    class="layout__back-button"
    *ngIf="!hideBackButton"
    [title]="backBtnTitle || ('BACK_BUTTON.TITLE' | translate)"
    (back)="backBtnClick.emit()"
    [hideTextMobile]="hideTextMobile"
    arrowLeftIcon="verti-arrow-simple-left-24"
  ></qb-ita-back-button>
</ng-template>
